import { useMemo, useState } from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { DestinationCard } from "@/components/Cards";
import { useContent } from "@/lib/content";

export default function DestinationListing({ region, title, overline, description, image, seoTitle, seoDesc }) {
  const { destinations, loading } = useContent();
  const [query, setQuery] = useState("");

  const list = useMemo(() => {
    let l = destinations.filter((d) => d.region === region);
    if (query.trim()) {
      const q = query.trim().toLowerCase();
      l = l.filter((d) => d.name.toLowerCase().includes(q) || d.tagline.toLowerCase().includes(q));
    }
    return l;
  }, [destinations, region, query]);

  return (
    <div data-testid={`listing-${region.toLowerCase()}`}>
      <SEO title={seoTitle} description={seoDesc} />
      <PageHero image={image} overline={overline} title={title} description={description} />
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <p className="text-sm text-slate-500">{list.length} destination{list.length !== 1 ? "s" : ""} — click any card to explore packages, visa info, best seasons and more.</p>
            <input
              data-testid="listing-search-input"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={`Search ${region === "India" ? "India" : "international"} destinations...`}
              className="h-11 w-full sm:w-72 rounded-xl border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-skybrand"
            />
          </div>
          {loading ? (
            <p className="mt-10 text-slate-400">Loading destinations...</p>
          ) : list.length === 0 ? (
            <p className="mt-10 text-slate-500" data-testid="listing-empty">No destinations match your search. Try another name.</p>
          ) : (
            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {list.map((d, i) => <Reveal key={d.slug} delay={(i % 4) * 0.05}><DestinationCard dest={d} /></Reveal>)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
